<template>
  <div class="active-user">
    <div class="active-user__close-cross" v-if="showCloseCross" @click="$emit('close')">
      <span class="icon-cross2"></span>
    </div>
    <div class="active-user__title">
      <div class="active-user__title__bttn icon__bg-circle hint--right"
           @click="emitShowUserTasks"
           :aria-label="$t('vue2.task_overview.task_and_hour_overview')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon-chart tw-icon tw-icon--small">
          <path class="primary"
                d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"/>
          <path class="secondary"
                d="M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"/>
        </svg>
      </div>
      <h2 class="marg-10-bottom">{{ allUsersInHash[activeUserId].name }}</h2>
    </div>
    <button v-if="canSeeSubjectRequests && userSubjectRequests.length > 0"
            class="marg-10-bottom do-bttn do-bttn--small"
            @click="openSubjectRequests">Se fagønsker ({{ userSubjectRequests.length }})</button>
    <TasksTable :title="i18n[locale]['subjects']"
                hoursTitle="UV"
                id="teaching"
                :tasks="getAllUserSubjectsAndTeachingTasks"
                :user="allUsersInHash[activeUserId]"
                :userCalendarId="userCalId"
                @edit="setEditSubject"
                @setActiveSubject="setActiveSubject"
                @setActiveTaskSubject="setActiveTaskSubject"
                :assignedHours="getUserAssignedTeachingHours(activeUserId)"
                :isTeaching="true"
                :isPoolsDeactivated="isPoolsDeactivated"
                :showLessonsPerWeek="showLessonsPerWeek">
    </TasksTable>

    <TasksTable :title="i18n[locale]['additional_tasks']"
                id="tasks"
                hoursTitle="Øvrig"
                :user="allUsersInHash[activeUserId]"
                :tasks="getAllUserTasksTask"
                :userCalendarId="userCalId"
                @edit="setEditSubject"
                @setActiveSubject="setActiveSubject"
                @setActiveTaskSubject="setActiveTaskSubject"
                :assignedHours="getUserAssignedTaskHours(activeUserId)"
                :isPoolsDeactivated="isPoolsDeactivated">
    </TasksTable>
    <TasksTable :title="i18n[locale]['preparation']"
                id="preperation"
                hoursTitle="Forb."
                :user="allUsersInHash[activeUserId]"
                :tasks="getAllUserTasksPrep"
                :userCalendarId="userCalId"
                @edit="setEditSubject"
                @setActiveSubject="setActiveSubject"
                @setActiveTaskSubject="setActiveTaskSubject"
                :assignedHours="getUserAssignedPreparationHours(activeUserId)"
                :isPoolsDeactivated="isPoolsDeactivated">
    </TasksTable>
    <TasksTable
      v-if="getAllUserTasksClub.length > 0"
      :title="i18n[locale]['club']"
      id="club"
      hoursTitle="SFO."
      :user="allUsersInHash[activeUserId]"
      :tasks="getAllUserTasksClub"
      :userCalendarId="userCalId"
      @edit="setEditSubject"
      @setActiveSubject="setActiveSubject"
      @setActiveTaskSubject="setActiveTaskSubject"
      :assignedHours="getUserAssignedClubHours(activeUserId)"
      :isPoolsDeactivated="isPoolsDeactivated">
    </TasksTable>
    <TasksTable
      v-if="isSchoolFeatureLocalePool && getAllUserTasksPool.length > 0"
      :title="localPoolTitle"
      id="pool"
      :hoursTitle="localPoolTitle"
      :user="allUsersInHash[activeUserId]"
      :tasks="getAllUserTasksPool"
      :userCalendarId="userCalId"
      @edit="setEditSubject"
      @setActiveSubject="setActiveSubject"
      @setActiveTaskSubject="setActiveTaskSubject"
      :assignedHours="getUserAssignedPoolHours(activeUserId)"
      :isPoolsDeactivated="isPoolsDeactivated">
    </TasksTable>
    <TasksTable
      v-if="getAllUserTasksAvailable.length > 0"
      :title="i18n[locale]['available']"
      id="available"
      hoursTitle="Råd."
      :user="allUsersInHash[activeUserId]"
      :tasks="getAllUserTasksAvailable"
      :userCalendarId="userCalId"
      @edit="setEditSubject"
      @setActiveSubject="setActiveSubject"
      @setActiveTaskSubject="setActiveTaskSubject"
      :assignedHours="0"
      :isPoolsDeactivated="isPoolsDeactivated">
    </TasksTable>
    <div class="active-user__agreements">
      <SubjectsDistributionUserAgreements :userId="activeUserId"></SubjectsDistributionUserAgreements>
    </div>
    <transition name="d-modal">
      <DModal v-if="showSubjectRequests" @close="showSubjectRequests = false">
        <div slot="insertComponent" class="subject-requests-modal">
          <h3 class="subject-requests-modal__title">Fagønsker for {{ allUsersInHash[activeUserId].name }}</h3>
          <div v-if="isLoadingSubjectRequests" class="subject-requests-modal__loading">
            <div class="do-spinner"></div>
          </div>
          <template v-else>
            <table class="d-table" v-if="userSubjectRequests.length > 0">
              <thead>
                <tr>
                  <th>Fag</th>
                  <th>Klasse</th>
                  <th class="is-number">Timer</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="subject in userSubjectRequests" :key="subject.id">
                  <td>
                    <div class="subjects_subject"
                         :style="{'background-color': subject.color}">
                      {{ subject.name }}
                    </div>
                  </td>
                  <td>{{ subject.vKlass }}</td>
                  <td class="is-number">{{ subject.vHours }}</td>
                </tr>
              </tbody>
            </table>
            <p v-else class="subject-requests-modal__empty">Ingen fagønsker registreret</p>
          </template>
        </div>
      </DModal>
    </transition>
    <div class="bg-overlay"
         v-if="showSubjectRequests"
         @click="showSubjectRequests = false">
    </div>
    <transition name="d-modal">
      <DModal v-if="theActiveSubject && getTheActiveSubject" :showClose="false" @close="closeActiveSubject" style="border-radius: 4px">
        <SubjectsDistributionUserEditHours
          slot="insertComponent"
          :subject="getTheActiveSubject"
          :teacher="getTheActiveUser"
          :task="theActiveTask"
          @close="closeActiveSubject"/>
      </DModal>
    </transition>
    <div class="bg-overlay"
         v-if="theActiveSubject && getTheActiveSubject"
         @click="closeActiveSubject">
    </div>
  </div>
</template>

<script>
import SubjectsDistributionUserAgreements from './SubjectsDistributionUserAgreements'
import SubjectsDistributionUserEditHours from './SubjectsDistributionUserEditHours'
import TasksTable from './SubjectsDistributionUserTable'
import DDropdown from '../common/DDropdown'
import DModal from '../common/DModal'

const I18N = {
  da: {
    subjects_for_teachers: 'Fagfordeling',
    filter_users: ' Filtrer på teams',
    teaching_hours_from_subjects: 'UV-TID FRA FAG',
    created_subject: 'Oprettede faget',
    klass: 'Tilhører',
    subjects: 'Undervisning',
    teaching_hours: 'UV tid',
    no_subjects_assigned: 'Ingen fag tildelt',
    assigned: 'Tildelt',
    from_subjects: 'Fra fag',
    difference: 'Diff',
    only_subjects_without_teachers: 'Vis kun fag uden underviser',
    hours_in_school_year: 'Timer i skoleåret',
    time: 'Timer',
    additional_tasks: 'Øvrige opgaver',
    preparation: 'Forberedelse',
    club: 'SFO',
    pool: 'Lokalpulje',
    available: 'Rådighedstimer'
  },
  en: {
    subjects_for_teachers: 'Teacher-subject allocation',
    filter_users: ' Filter users by groups',
    teaching_hours_from_subjects: 'Annual instruction time from subjects',
    created_subject: 'Created subject',
    klass: 'Class',
    subjects: 'Subjects',
    teaching_hours: 'Instruction time',
    no_subjects_assigned: 'No subjects allocated',
    assigned: 'Allocated',
    from_subjects: 'From subjects',
    difference: 'Diff',
    only_subjects_without_teachers: 'Show only subjects without teachers',
    hours_in_school_year: 'Annual Instruction Time',
    time: 'Hours',
    additional_tasks: 'Not teaching',
    preparation: 'Preparation',
    club: 'club',
    pool: 'Custom pool',
    available: 'Available hours'
  },
  nb: {
    subjects_for_teachers: 'Fag- og lærerfordeling',
    filter_users: ' Filtrer etter gruppe',
    teaching_hours_from_subjects: 'Årstimetall',
    created_subject: 'Opprettet faget',
    klass: 'Klasse',
    subjects: 'Fag',
    teaching_hours: 'Timetall',
    no_subjects_assigned: 'Ingen fag tildelt',
    assigned: 'Tildelt',
    from_subjects: 'Fra fag',
    difference: 'Diff',
    only_subjects_without_teachers: 'Vis kun fag uten underviser',
    hours_in_school_year: 'Timer i skoleåret',
    time: 'Timer',
    additional_tasks: 'Øvrige oppgaver',
    preparation: 'Forberedelse',
    club: 'SFO',
    pool: 'Planleggingsdager',
    available: 'Rådighetstimer'
  }
}

export default {
  components: {SubjectsDistributionUserAgreements, DDropdown, DModal, SubjectsDistributionUserEditHours, TasksTable},
  props: {
    activeUserId: {
      default: null
    },
    showCloseCross: {
      default: true
    },
    isPoolsDeactivated: {
      type: Boolean,
      default: false
    },
    showLessonsPerWeek: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isPrint: false,
      theActiveSubject: null,
      theActiveTask: null,
      userTasksTasks: [],
      showSubjectRequests: false
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      return I18N
    },
    getTheActiveSubject () {
      if (!this.theActiveSubject) return null
      return this.subjectsInHash[this.theActiveSubject] || this.tasksInHash[this.theActiveSubject] || null
    },
    getTheActiveUser () {
      return this.activeUserId ? this.allUsersInHash[this.activeUserId] : null
    },
    isTestSchool () {
      return window.SCHOOL.country === 'DK'
    },
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    },
    subjectsInUserHash () {
      return this.$store.getters.subjectsInUserHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    usersAssignedHoursHash () {
      return this.$store.getters.usersAssignedHoursHash
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    tasksInUserHash () {
      return this.$store.getters.tasksInUserHash
    },
    tasksInHash () {
      return this.$store.getters.tasksInHash
    },
    userCalId () {
      return this.allUsersInHash[this.activeUserId].user_calendar_id
    },
    subjects () {
      return this.$store.state.subjects.subjects
    },
    allUserTasks () {
      return this.subjects.filter(subject => {
        if (subject.calendar_id === this.userCalId) return true
        return Array.isArray(subject.cals) &&
          subject.cals.some(cal => cal.calendar_type === 'user' && cal.id === this.userCalId)
      })
    },
    getAllUserTasksTask () {
      return this.allUserTasks.filter(task => task.subject_type === 'additional_tasks')
    },
    getAllUserTasksPrep () {
      return this.allUserTasks.filter(task => task.subject_type === 'preparation')
    },
    getAllUserTasksClub () {
      return this.allUserTasks.filter(task => task.subject_type === 'club')
    },
    getAllUserTasksPool () {
      return this.allUserTasks.filter(task => task.subject_type === 'pool')
    },
    getAllUserTasksAvailable () {
      return this.allUserTasks.filter(task => task.subject_type === 'available')
    },
    isSchoolFeatureLocalePool () {
      return this.$store.getters.isSchoolFeatureLocalePool
    },
    localPoolTitle () {
      const title = this.$store.getters.localPoolTitle
      return title || this.i18n[this.locale]['pool']
    },
    getAllUserTasksTeaching () {
      return this.allUserTasks.filter(task => {
        if (task.subject_type !== 'subject' && task.subject_type !== 'person_resource' && task.subject_type !== 'person_resource_visible') return false
        const ownerCal = this.allCalendarsInHash[task.calendar_id]
        return ownerCal && ownerCal.type === 'user'
      })
    },
    currentUser () {
      return this.$store.state.user
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    canSeeSubjectRequests () {
      if (!this.currentUser) return false
      if (!this.isPermissionsActivatedForSchool) return true
      return (this.userPermissions && this.userPermissions.indexOf('can_see_other_subject_requests') > -1) || this.currentUser.admin
    },
    activeSchoolYearId () {
      return this.$store.getters.schoolYearId
    },
    isLoadingSubjectRequests () {
      return this.$store.state.subjects.isLoadingSubjectsRequests
    },
    subjectsRequests () {
      return this.$store.state.subjects.subjectsRequests
    },
    userSubjectRequests () {
      const userCalId = this.userCalId
      const requestedSubjectIds = this.subjectsRequests
        .filter(req => req.calendar_id === userCalId)
        .map(req => req.subject_id)

      return requestedSubjectIds
        .map(subjectId => {
          const subject = this.subjectsInHash[subjectId]
          if (!subject) return null
          const cal = this.allCalendarsInHash[subject.calendar_id]
          return {
            ...subject,
            vKlass: cal ? cal.name : '',
            vHours: this.getSubjectHoursForKlass(subject)
          }
        })
        .filter(s => s !== null)
        .sort((a, b) => a.name.localeCompare(b.name))
    },
    getAllUserSubjectsAndTeachingTasks () {
      let calId = this.userCalId
      let subjects = this.subjectsInUserHash[calId] ? this.subjectsInUserHash[calId].map(subjectId => this.subjectsInHash[subjectId]) : []
      subjects = subjects.filter(subject => {
        if (this.allCalendarsInHash[subject.calendar_id]) {
          const calendarType = this.allCalendarsInHash[subject.calendar_id].type
          return calendarType === 'klass' || calendarType === 'merge'
        } else {
          console.log('error::calendar not found', subject.calendar_id)
        }
      })
      return subjects.concat(this.getAllUserTasksTeaching)
    }
  },
  methods: {
    openSubjectRequests () {
      this.showSubjectRequests = true
      if (this.activeSchoolYearId) {
        this.$store.dispatch('readSubjectRequests', this.activeSchoolYearId)
      }
    },
    emitShowUserTasks () {
      this.$emit('showUserTasks', this.allUsersInHash[this.activeUserId])
    },
    getSubjectHoursForKlass (subject) {
      if (subject.subject_calendars) {
        const entry = subject.subject_calendars.find(function (sc) { return sc.calendar_id === subject.calendar_id })
        if (entry && entry.hours != null) {
          return entry.hours
        }
      }
      return subject.hours
    },
    getUserAssignedTaskHours (userId) {
      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_additional_task_hours ? this.usersAssignedHoursHash[userId].assigned_additional_task_hours : 0
    },
    getUserAssignedPreparationHours (userId) {
      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_preparation_hours ? this.usersAssignedHoursHash[userId].assigned_preparation_hours : 0
    },
    getUserAssignedClubHours (userId) {
      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_club_hours ? this.usersAssignedHoursHash[userId].assigned_club_hours : 0
    },
    getUserAssignedPoolHours (userId) {
      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_pool_hours ? this.usersAssignedHoursHash[userId].assigned_pool_hours : 0
    },
    getAllUserSubjects (calid) {
      let subjects = this.subjectsInUserHash[calid] ? this.subjectsInUserHash[calid] : []
      return subjects.sort((subjectA, subjectB) => {
        let subjectFromSubjectA = this.allCalendarsInHash[this.subjectsInHash[subjectB].calendar_id]
        let subjectFromSubjectB = this.allCalendarsInHash[this.subjectsInHash[subjectA].calendar_id]
        if ((subjectFromSubjectA && subjectFromSubjectA.name) && (subjectFromSubjectB && subjectFromSubjectB.name)) {
          return subjectFromSubjectA.name.localeCompare(subjectFromSubjectB.name, undefined, {
            numeric: true,
            sensitivity: 'base'
          })
        }
      })
    },
    setEditSubject (editSubject) {
      this.$emit('editSubject', editSubject)
    },
    setDeleteTask (taskId) {
      let task = this.tasksInHash[taskId]
      task['itemType'] = 'task'
      this.$store.commit('setItemToDelete', task)
      this.$store.commit('setConfirmDeletion', true)
    },
    getUserAssignedTeachingHours (userId) {
      return this.usersAssignedHoursHash[userId] ? this.usersAssignedHoursHash[userId].assigned_teaching_hours : 0
    },
    setActiveSubject (subject) {
      this.theActiveTask = null
      this.theActiveSubject = subject
    },
    setActiveTaskSubject (task) {
      let subjectId = null
      if (task.subjects && task.subjects.length) {
        const match = task.subjects.find(s =>
          s.user_calendars && s.user_calendars.includes(this.userCalId)
        )
        subjectId = match ? match.id : (task.subjects[0] ? task.subjects[0].id : null)
      }
      if (!subjectId) subjectId = task.id
      this.theActiveTask = task
      this.theActiveSubject = subjectId
    },
    closeActiveSubject () {
      this.theActiveSubject = null
      this.theActiveTask = null
    }
  }
}
</script>


<style scoped>

.active-user {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

.active-user h2 {
  margin-right: 20px;
}

.active-user__title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.active-user__title__bttn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.active-user__title__bttn .tw-icon {
  width: 1.7rem;
}

.active-user__title__bttn .secondary {
  fill: #0D2B3E;
}

.active-user__title__bttn .primary {
  fill: #a5b3bb;
}

.active-user__close-cross {
  position: absolute;
  z-index: 100;
  top: 0;
  right: 0;
  border-radius: 50%;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.15s;
}

.active-user__close-cross:hover {
  background: #eee;
}

.d-table, .subjects-and-tasks {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
}

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th, .d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 2px 4px;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 4px;
}

.subjects_subject {
  position: relative;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  margin: 2.5px 5px 2.5px 0px;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.is-number {
  text-align: right;
}

tbody tr:first-child td .subjects_subject {
  margin-top: 5px;
}

tbody tr:last-child td .subjects_subject {
  margin-bottom: 10px;
}

.active-user__agreements {
  margin-top: 10px;
}

.subject-hours-for-person {
  position: relative;
  cursor: pointer;
  transition: transform 0.25s;
}

.subject-hours-for-person:hover {
  transform: translateY(-1px);
  text-decoration: underline;
  color: #468AD7;
}

.subject-requests-modal {
  padding: 1.5rem;
  min-width: 380px;
  max-width: 500px;
  max-height: 70vh;
  overflow-y: auto;
}

.subject-requests-modal__title {
  margin: 0 0 1rem 0;
  color: #3e4450;
}

.subject-requests-modal__empty {
  color: #8898aa;
  font-style: italic;
}

.subject-requests-modal__loading {
  display: flex;
  justify-content: center;
  padding: 2rem 0;
}

.subject-requests-modal .d-table {
  margin-top: 0;
}

.subject-hours-for-person.subject-hours-for-person--is-modified:after {
  content: "\e904";
  position: absolute;
  bottom: 10px;
  padding: 4px;
  left: 0px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  -webkit-font-feature-settings: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.do-bttn.do-bttn--small {
  font-size: 11px;
  height: auto;
  padding: 5px 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// SubjectsDistributionUser.vue?2f28560e